module.exports = __webpack_public_path__ + "img/CommerceHealthcare_Logo.99fc1020.png";